<div class="signin-wrap">
  <section class="signin-box">
    <div class="signin-head text-center mb-3">
      <img class="" src="../../assets/images/logo_signin_smile9.png">
      <div><small class="version text-muted">{{VERSION}}</small></div>
    </div>
    <div class="signin-body">
      <!-- 入力フォームでの認証 -->
      <ng-container *ngIf="!authServ.isLoading">
        <ng-container *ngIf="inputType === InputType.InputForm">
          <div class="text-center mb-2">smile9IDを読み取り端末でスキャンしてください。</div>

          <label class="signin-label">
            {{labelFelicaId}}
            <span *ngIf="smile9IdPrefix === null" class="oi oi-globe pl-1 text-secondary"></span>
          </label>
          <div class="password-wrap">
            <div *ngIf="smile9IdPrefix !== null" class="prefix">{{smile9IdPrefix}}</div>
            <div class="input">
              <input autofocus id="felicaId" inputmode="url" name="felicaId" class="w-100 text-left"
                [formControl]="felicaId"
                [attr.type]="felicaIdType"
                (keyup.enter)="clickSignin()">
            </div>
            <div class="eye-style" [ngSwitch]="felicaIdType">
              <span *ngSwitchCase="'password'" class="oi oi-eye text-muted" (click)="felicaIdType = 'text';"></span>
              <span *ngSwitchCase="'text'" class="oi oi-eye text-danger" (click)="felicaIdType = 'password';"></span>
            </div>
          </div>
          <div class="text-right"><button type="button" class="btn btn-outline-dark btn-lg" (click)="felicaId.reset()">クリア</button></div>
          <div class="text-right mt-3">
            <button type="button" class="btn btn-warning btn-lg" (click)="clickSignin()">手動で認証する</button>
          </div>
        </ng-container>
      </ng-container>

        <!-- テンキーによる認証 -->
        <ng-container *ngIf="!authServ.isLoading">
          <ng-container *ngIf="inputType === InputType.Tenkey">
            <div class="password-wrap">
              <div *ngIf="smile9IdPrefix !== null" class="prefix">{{smile9IdPrefix}}</div>
              <div class="input">
                <input autofocus id="felicaId" inputmode="url" name="felicaId" class="w-100 text-left"
                  [(ngModel)]="felicaId.value"
                  [formControl]="felicaId"
                  [attr.type]="felicaIdType"
                  (keyup.enter)="clickSignin()"
                  (click)="removeSoftwareKeyboard()"
                  (blur)="changeInputMode()">
              </div>
              <div class="eye-style" [ngSwitch]="felicaIdType">
                <span *ngSwitchCase="'password'" class="oi oi-eye text-muted" (click)="felicaIdType = 'text';"></span>
                <span *ngSwitchCase="'text'" class="oi oi-eye text-danger" (click)="felicaIdType = 'password';"></span>
              </div>
            </div>
            <section id="numeric-keypad">
              <div id="calc" class="row">
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="clickCalcButton(7)">7</button>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="clickCalcButton(8)">8</button>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="clickCalcButton(9)">9</button>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="oneClearFelicaId()"><span class="oi oi-delete"></span></button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="clickCalcButton(4)">4</button>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="clickCalcButton(5)">5</button>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad">
                    <button class="btn btn-outline-dark" (click)="clickCalcButton(6)">6</button>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad clear-words">
                    <button class="btn btn-outline-dark" (click)="clearFelicaId()">クリア</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-9">
                  <div class="row">
                    <div class="col-4">
                      <div class="keypad">
                        <button class="btn btn-outline-dark" (click)="clickCalcButton(1)">1</button>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="keypad">
                        <button class="btn btn-outline-dark" (click)="clickCalcButton(2)">2</button>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="keypad">
                        <button class="btn btn-outline-dark" (click)="clickCalcButton(3)">3</button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <div class="keypad">
                        <button class="btn btn-outline-dark" (click)="clickCalcButton(0)">0</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="keypad start-auth">
                    <button class="btn btn-warning" (click)="clickSignin()">認証</button>
                  </div>
                </div>
              </div>
            </section>
          </ng-container>
        </ng-container>
      <div *ngIf="authServ.isLoading" class="loading-area-sm">
        <app-loading [loadImgClass]="loadImgClass"></app-loading>
      </div>
    </div>
    <ng-container *ngIf="!authServ.mode.firstPassSettingMode && !authServ.mode.forgotPassMode && !authServ.mode.inputCodeMode">
      <div class="text-center text-muted mt-4 ml-3">
        <small>Powerd by S.K.S. Inc.</small>
      </div>
    </ng-container>
  </section>

  <div id="fullscreen-btns">
    <button *ngIf="!utilServ.uUI.isFullScreen()" id="fullscreen-on" class="btn btn-dark" (click)="utilServ.uUI.fullScreen()">
      <span class="oi oi-fullscreen-enter"></span>
    </button>
    <button *ngIf="utilServ.uUI.isFullScreen()" id="fullscreen-off" class="btn btn-dark" (click)="utilServ.uUI.cancelFullScreen()">
      <span class="oi oi-fullscreen-exit"></span>
    </button>
  </div>
  <div *ngIf="inputType === InputType.InputForm" class="button-left mt-5">
    <button type="button" class="btn btn-dark btn-lg" (click)="changeInputType(InputType.Tenkey)"><img [src]="utilServ.uUI.icongram('feather','refresh-cw',20,'FFFFFF')">&nbsp;テンキー表示</button>
  </div>
  <div *ngIf="inputType === InputType.Tenkey" class="button-left mt-5">
    <button type="button" class="btn btn-secondary btn-lg" (click)="changeInputType(InputType.InputForm)"><img [src]="utilServ.uUI.icongram('feather','refresh-cw',20,'FFFFFF')">&nbsp;テンキー非表示</button>
  </div>
</div>
